import { render, staticRenderFns } from "./AltTrustPilot.vue?vue&type=template&id=1e85ecba&scoped=true&"
import script from "./AltTrustPilot.vue?vue&type=script&lang=js&"
export * from "./AltTrustPilot.vue?vue&type=script&lang=js&"
import style0 from "./AltTrustPilot.vue?vue&type=style&index=0&id=1e85ecba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e85ecba",
  null
  
)

export default component.exports